export default [
  {
    path: 'comprobantes/:id/facturar',
    name: 'invoiceReceipt',
    meta: { permiso: '*', requiereLogin: true }, // TODO: SET PERMISSION
    component: () => import('@/febos/aduanas/receipts/views/InvoiceReceipt')
  },
  {
    path: 'comprobantes/facturar-masivo',
    name: 'invoiceReceiptMassive',
    meta: { permiso: '*', requiereLogin: true }, // TODO: SET PERMISSION
    component: () => import('@/febos/aduanas/receipts/views/InvoiceReceipt')
  }
];
